import { CountriesService_countryServiceGetAbbreviatedCountryNames } from '@festina/legalentity-general-types/legalentity/hooks/CountriesService_countryServiceGetAbbreviatedCountryNames'

export const useFetchAbbreviatedCountryNames =
  CountriesService_countryServiceGetAbbreviatedCountryNames.useSuspenseQuery
